export default {"src":"/_next/static/media/download-report-icon.f91b62ec.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};